export default __webpack_public_path__ + "static/media/sharepoint.d6ed9ac4.png";